// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2oHNT","tab":"ProcedureTabs_tab__11ReB"};